import { afterGet as globalAfterGet } from "services/sosInventoryService/afterGet";
import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/upsShipment/schema";
import { transformFields } from "services/utility/afterGet";
import { isoToDateTime } from "services/utility/dates";

import { format } from "date-fns";

export function afterGet(record) {
  const newRecord = transformFields(record, FIELDS_TO_TRANSFORM);
  return globalAfterGet(newRecord);
}

export function afterGetRates(rate) {
  const {
    estimatedArrivalDate,
    estimatedArrivalTime,
    serviceCode,
    service,
    saturdayDelivery,
  } = rate;

  // Always expect both estimatedArrivalDate and estimatedArrivalTime
  const isoString = `${estimatedArrivalDate}T${estimatedArrivalTime}`;
  const dateObj = isoToDateTime(isoString);
  let formatted = "";
  formatted = format(dateObj, "EEEE, MMMM d 'at' h:mma");
  formatted = formatted.replace("AM", "a").replace("PM", "p");
  return {
    ...rate,
    estimatedArrival: formatted,
    id: saturdayDelivery ? `${serviceCode}_saturday` : serviceCode,
    name: `${service}${saturdayDelivery ? " (Saturday delivery)" : ""}`,
  };
}
